/**
 * @typedef {Object} OnboardingHintRegistration
 * @property {number} priority
 * @property {boolean} eligible
 */

/**
 * @param {Map<string, OnboardingHintRegistration>} registrations
 * @param {ReadonlySet<string>} sessionDismissed
 * @returns {string | null}
 */
export function selectActiveOnboardingHint(registrations, sessionDismissed) {
  let bestId = null;
  let bestPriority = Infinity;

  for (const [id, entry] of registrations.entries()) {
    if (sessionDismissed.has(id)) {
      continue;
    }
    if (!entry.eligible) {
      continue;
    }
    if (entry.priority < bestPriority) {
      bestPriority = entry.priority;
      bestId = id;
    }
  }

  return bestId;
}
